import { onAuthStateChanged } from "firebase/auth";
import {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { auth } from "../firebase";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => auth.currentUser);
  const [loading, setLoading] = useState(() => !auth.currentUser);
  const [error, setError] = useState(null);

  useEffect(() => {
    let settled = Boolean(auth.currentUser);
    const timeoutId = window.setTimeout(() => {
      if (settled) return;

      settled = true;
      setError(new Error("ตรวจสอบสถานะผู้ใช้ใช้เวลานานเกินไป"));
      setLoading(false);
    }, 15000);

    const unsubscribe = onAuthStateChanged(
      auth,
      (nextUser) => {
        settled = true;
        window.clearTimeout(timeoutId);
        setUser(nextUser);
        setError(null);
        setLoading(false);
      },
      (authError) => {
        settled = true;
        window.clearTimeout(timeoutId);
        setError(authError);
        setLoading(false);
      },
    );

    return () => {
      settled = true;
      window.clearTimeout(timeoutId);
      unsubscribe();
    };
  }, []);

  const value = useMemo(
    () => ({ user, loading, error }),
    [user, loading, error],
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error("useAuth must be used inside AuthProvider");
  }

  return context;
}
